import { render, staticRenderFns } from "./client-profile-changelog.vue?vue&type=template&id=b3fc1c42"
import script from "./client-profile-changelog.vue?vue&type=script&lang=js"
export * from "./client-profile-changelog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports